import React from "react";
import { Chip, Table } from "../../../../components/core";
import { useMatch } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { DELETE_PARTNER_BRANCH_ASSIGNMENT } from "../../../../constants/graphql/locker-queries";

export default function OutputTable({
	classname,
	items,
	headers,
	refetch,
	onDelete,
	title,
	lockerType,
	disabled = false,
}) {
	const [deletePartnerBranchAssignment] = useMutation(
		DELETE_PARTNER_BRANCH_ASSIGNMENT
	);
	const onHadleDelete = (event, partnerBranchAssignmentId, doorsOccupied) => {
		onDelete(event, partnerBranchAssignmentId, doorsOccupied);
	};
	return (
		<div className="bg-gray-100 p-2">
			<p className="font-bold text-xl my-4">
				Current {title} Locker-Branch Assignment:
			</p>
			<p className="font-bold text-xl my-4 text-center">
				{title} : {lockerType} Lockers
			</p>
			<table className="w-full">
				<tr className="bg-primary-primaryYellow h-16">
					{headers.map((data, key) => {
						return (
							<th className="text-left p-2" key={key}>
								{key === 1 ? title : ""}
								{key === 0 ? lockerType : ""} {data.header_name}
							</th>
						);
					})}
				</tr>
				{items.map((data, key) => {
					return (
						<tr className="h-12 even:bg-gray-100 bg-white">
							{headers.map((headerData, headerKey) => {
								if (Array.isArray(data[headerData.header_key])) {
									return (
										<td
											className="px-2 py-4 border-b-2 border-stone-400"
											key={headerKey}
										>
											{data[headerData.header_key].map(
												(branchData, branchKey) => {
													return (
														<Chip
															className="m-2"
															label={branchData.partnerBranch}
															key={branchKey}
															disabled={disabled}
															onDelete={(event) =>
																onHadleDelete(
																	event,
																	branchData.partnerBranchAssignmentId,
																	branchData.doorsOccupied
																)
															}
														/>
													);
												}
											)}
										</td>
									);
								}
								return (
									<td
										className="px-2 py-4 border-b-2 border-stone-400"
										key={headerKey}
									>
										{data[headerData.header_key]}
									</td>
								);
							})}
						</tr>
					);
				})}
			</table>
		</div>
	);
}
